(function () {
  'use strict';

  angular.module('ringbaPortal')
    .component('loginV2', {
      controller: LoginV2Controller,
      controllerAs: 'vm',
      templateUrl: '/scripts/components/auth/v2/loginv2.view.html'
    });

  function LoginV2Controller
  ($stateParams,
    cacheService,
    whitelabelService
  ) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;
    vm.isWhitelabeledSite = false;

    function onInit() {
      _setInvitedUserName();
      _checkPreviewMode();
      vm.showRegisterLink = whitelabelService.checkLocationHostIsBase() && !$stateParams.preview;
      vm.isWhitelabeledSite = !whitelabelService.checkLocationHostIsBase() || $stateParams.preview == 'true';
    }

    function _setInvitedUserName() {
      if ($stateParams.invited) {
        vm.invitedUserName = $stateParams.fname;
        vm.newUser = $stateParams.nuser;
      }
    }

    function _checkPreviewMode() {
      if ($stateParams.preview) {
        vm.previewModeEnabled = true;
        vm.currentTheme = cacheService.get('login-preview');
        vm.isLightTheme = vm.currentTheme.isLightTheme;
        cacheService.remove('login-preview');
      }
    }

  }
})();
